import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'materials',
components: {
XTable,
},
data () {
return {
am:'<2.5%',
activeIndex:1,
metalActive:3,
typeActive:'plastic'
}
},
methods: {

},
created () {

}
}



// WEBPACK FOOTER //
// ./src/views/materials/script.js